import { render, staticRenderFns } from "./ControlDetail.vue?vue&type=template&id=732a5efc&scoped=true&"
import script from "./ControlDetail.vue?vue&type=script&lang=js&"
export * from "./ControlDetail.vue?vue&type=script&lang=js&"
import style0 from "./ControlDetail.vue?vue&type=style&index=0&id=732a5efc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732a5efc",
  null
  
)

export default component.exports